import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius } from "../../../design-system/tokens/borders";

export const StyledActionButton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing[1]};
  padding: 6px ${spacing[2]} 6px ${spacing[3]};
  border-radius: ${borderRadius.lg};
  border: 1px solid ${rawColors.stroke[200]};
  background-color: ${rawColors.structural.white};
  color: ${rawColors.primary[500]};
  ${typographyMixin("caption", 3)}
  cursor: pointer;
  user-select: none;
  text-decoration: none;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;
